import $ from "jquery";
import uniqueId from "lodash/uniqueId";
import startsWith from "lodash/startsWith";

const NAVBAR_HEIGHT = 90;

export function connect(opts) {
    let fixBlockId = opts.block.attr("id");
    const $beforeBlock = opts.beforeBottom || opts.beforeTop;
    const $untilBlock = opts.untilBottom || opts.untilTop;
    if (!opts.block.is(":visible")) {
        return;
    }
    if (!fixBlockId || startsWith(fixBlockId, "fixed-block-")) {
        fixBlockId = uniqueId("fixed-block-");
        opts.block.attr("id", fixBlockId);
    }

    $(window).on(`scroll.${fixBlockId}`, _fix);
    function _fix() {
        const windowOffset = $(window).scrollTop() + NAVBAR_HEIGHT;
        const beforeHeight = opts.beforeBottom ? $beforeBlock.height() : 0;
        const beforeLine = $beforeBlock.offset().top + beforeHeight;
        const untilHeight = opts.untilBottom ? $untilBlock.height() : 0;
        const untilLine = $untilBlock.offset().top + untilHeight;
        const stayAtBottom = untilLine < windowOffset + opts.block.height();
        const canFit = untilLine - beforeLine > opts.block.height();
        const weAreBefore = windowOffset <= beforeLine;
        const isFixedBlock = opts.block.hasClass("fixed-block");
        const isBottomBlock = opts.block.hasClass("fixed-block-bottom");
        if (!stayAtBottom && !weAreBefore && canFit && !isFixedBlock) {
            fixIt();
        } else if (stayAtBottom) {
            bottomIt(Math.max(untilLine - beforeLine - opts.block.height(), 0));
        } else if (weAreBefore && (isFixedBlock || isBottomBlock)) {
            unfixIt();
            unbottomIt();
        }
    }
    function fixIt() {
        const width = opts.block.width();
        opts.block.css({ width });
        opts.block.addClass("fixed-block");
        unbottomIt();
    }
    function unfixIt() {
        opts.block.removeClass("fixed-block");
    }
    function bottomIt(margin) {
        const oldMargin = parseInt(opts.block.css("marginTop"));
        if (oldMargin && Math.abs(oldMargin - margin) <= 1) {
            return;
        }
        opts.block.addClass("fixed-block-bottom");
        opts.block.css("margin-top", `${margin}px`);
        unfixIt();
    }
    function unbottomIt() {
        opts.block.removeClass("fixed-block-bottom");
        opts.block.css("margin-top", "");
    }
}
export function disconnect($block) {
    $block.removeClass("fixed-block");
    $block.find(".fixed-block").removeClass("fixed-block");
    if ($block.hasClass("fixed-block-bottom")) {
        $block.removeClass("fixed-block-bottom");
        $block.css("margin-top", "");
    }
    $(window).off(`scroll.${$block.attr("id")}`);
}
